import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'type', label: 'Type' },
  { key: 'start_date', label: 'Start' },
  { key: 'end_date', label: 'End' },
  { key: 'days', label: 'Days', align: 'right' },
  { key: 'status', label: 'Status' },
  { key: 'decided_by', label: 'Decided By' },
];

export function LeaveRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Leave Register"
      description="Every leave request with type, dates and decision status."
      endpoint="/reports/hr/leave"
      columns={COLUMNS}
      filters={['status', 'category', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
      categoryOptions={listOptions(lists, 'leave_type')}
      listColumns={{ type: 'leave_type' }}
    />
  );
}
